var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.erros.length > 0)?_c('app-erros-box',{attrs:{"erros":_vm.erros}}):_vm._e(),_c('app-tabela',{attrs:{"idTabela":"tblOcorrenciasInternas","itens":_vm.contrato.ocorrenciasInternas,"campos":_vm.campos,"itensPorPagina":_vm.itensPorPagina,"bordered":false,"small":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }